import React from "react";
import ListItemCore from "./ListItemCore";

export const ICON_TYPES = {
    INTERNAL_SVG: 'internalSvg',
    EXTERNAL_SVG: 'externalSvg',
    REACT_ICON: 'reactIcon'
};

const ListItem = props => {
    const {isDisclosureItem = false, tabIndex = 0, disabled = false, active = false, activeText = false, noHover = false, highlight = false, iconOnly = false, onClick, className, icon, iconType, iconSize, iconBg, tooltip, meta, url, value, alertText, ...other} = props;
    let activeProps = {};
    if (!disabled) {
        activeProps = {
            onClick: onClick,
            href: url || '#'
        };
    }

    if(disabled) {
        return  (
            <li className={'ch-list-item ch-list-item-disabled' + (active ? ' ch-list-item-active' : '') + (activeText ? ' ch-list-item-active-text' : '') + (noHover ? ' ch-list-item-no-hover' : '') + (className ? ' ' + className : '') + (highlight ? ' ch-list-item-highlight' : '')} aria-current={active ? 'page' : undefined}>
                <ListItemCore icon={icon} iconOnly={iconOnly} alertText={alertText} iconType={iconType} iconSize={iconSize} iconBg={iconBg} disabled={disabled} meta={meta} tooltip={tooltip}>
                    {props.children}
                </ListItemCore>
            </li>
        )
    }

    if (isDisclosureItem) {
        return <li className={'ch-list-item' + (active ? ' ch-list-item-active' : '') + (activeText ? ' ch-list-item-active-text' : '') + (noHover ? ' ch-list-item-no-hover' : '') + (className ? ' ' + className : '') + (highlight ? ' ch-list-item-highlight' : '')} aria-current={active ? 'page' : undefined}>
            <a className={'ch-nav-item'} tabIndex={tabIndex} {...activeProps} {...other}>
                <ListItemCore icon={icon} iconOnly={iconOnly} alertText={alertText} iconType={iconType} iconSize={iconSize} iconBg={iconBg} meta={meta} disabled={disabled} tooltip={tooltip}>
                    {props.children}
                </ListItemCore>
            </a>
        </li>
    }

    return (
        <li role={'none'} className={'ch-list-item' + (active ? ' ch-list-item-active' : '') + (activeText ? ' ch-list-item-active-text' : '') + (noHover ? ' ch-list-item-no-hover' : '') + (className ? ' ' + className : '') + (highlight ? ' ch-list-item-highlight' : '')} aria-current={active ? 'page' : undefined}>
            <a role="menuitem" className={'ch-nav-item'} tabIndex={tabIndex} {...activeProps} {...other}>
                <ListItemCore icon={icon} iconOnly={iconOnly} alertText={alertText} iconType={iconType} iconSize={iconSize} iconBg={iconBg} meta={meta} disabled={disabled} tooltip={tooltip}>
                    {props.children}
                </ListItemCore>
            </a>
        </li>
    )
}

export default ListItem;